import like from '../scss/comment-like-12-2.json';
import likeDark from '../scss/comment-like-12-dark-2.json';
import { query } from '@js/utils';
import Browser from '../../common/js/browser';

import { isNativeCode, showToast, cached } from '@js/utils';

const ua = window.navigator.userAgent.toLowerCase();

/**
 * 时间格式化
 * @param time
 * @returns {string}
 */
export function formatTime(time) {
  const timeInterval = Math.floor(new Date() / 1000) - time;
  let showTime = '';
  if (timeInterval > 24 * 60 * 60) {
    showTime = Math.floor(timeInterval / (24 * 60 * 60));
    showTime = `${showTime}天前`;
  } else if (timeInterval > 60 * 60) {
    showTime = Math.floor(timeInterval / (60 * 60));
    showTime = `${showTime}小时前`;
  } else {
    showTime = Math.floor(timeInterval / 60);
    if (showTime < 1) {
      showTime = '刚刚';
    } else {
      showTime = `${showTime}分钟前`;
    }
  }
  return showTime;
}

export function stat(statId, category, module, object) {
  let data = JSON.stringify(object) || '';
  if (window.wv.isMethodValid('generalStat')) {
    window.wv.generalStat(statId, category, module, data);
  }
}

export const getUserInfo = () => {
  if (process.env.NODE_ENV === 'development') {
    return null;
  }
  const res = window.wv.getUserInfo();
  if (res && res.code === 0) {
    return res.data;
  }
  return null;
};

// 获取卡片数据
export function getCardList() {
  const { sourceVal } = window.store;
  let sendData = {
    mediaId: window.pageData.DOCINFO.media.id,
    mediaNo: window.pageData.DOCINFO.media.outId,
    source: sourceVal,
  };
  return new Promise((resolve, reject) => {
    let reportData = {
      requestStatus: 0,
      result: 0,
    };
    let cardList = [];
    if (window.wv.isMethodValid('BrowserIFlow.requestCardList')) {
      window.wv.invoke(
        'BrowserIFlow.requestCardList',
        sendData,
        function (data) {
          if (data.data) {
            if (data.data === null || data.data.length < 3) {
              showToast('获取数据异常,请稍后再试');
              data.data = [];
            }
            cardList = data.data;
            cardList.forEach((v, i) => {
              v.index = i;
              v.isAttention = true;
            });
            reportData.result = 1;
          } else {
            reportData.result = 0;
          }
          resolve(cardList);
          reportData.requestStatus = 1;
          stat(20083636, 21034, 10012, reportData);
        },
      );
    } else {
      resolve(cardList);
    }
  });
}

// 获取是否从负一屏卡片跳转过来的信息
export function getIsShowMainAndrelatedNews() {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  let isShow = query.get('iflowScene');
  if (
    isShow &&
    isShow === 'card_assistantscreen' &&
    window.wv.isMethodValid('BrowserIFlow.jumpToNewsChannel')
  ) {
    return true;
  }
  return false;
}

/**
 * 另一个时间格式化
 * @param data
 * @param format
 * @returns {null}
 */
export function humanize(data, format) {
  const nowTime = parseInt(Date.now() / 1000);
  const publishTime = parseInt(data);
  const diff = nowTime - publishTime;

  let formatTime = null;
  let days = parseInt(diff / 86400);
  const day = parseInt(diff / 86400);
  const hour = diff % 86400;
  const hours = parseInt(hour / 3600);
  const minute = hour % 3600;
  const minutes = parseInt(minute / 60);

  const s = new Date(publishTime * 1000);
  const y = s.getFullYear();
  const M = s.getMonth() + 1;
  const d = s.getDate();
  const h = s.getHours();
  const m = s.getMinutes();

  function transform(single) {
    return single >= 10 ? single : '0' + single;
  }

  function getTodayZero() {
    const zero = new Date();
    zero.setHours(0);
    zero.setMinutes(0);
    zero.setSeconds(0);
    return zero;
  }

  if (publishTime < getTodayZero().getTime() / 1000) {
    days++;
  }

  const nowDate = parseInt(new Date().getDate());
  const publishDate = parseInt(new Date(publishTime * 1000).getDate());
  const thisYear = parseInt(new Date().getFullYear());
  const publishYear = parseInt(new Date(publishTime * 1000).getFullYear());

  const showTime = {
    time1: function () {
      if (day <= 0 && hours <= 0 && minutes <= 5) {
        return '刚刚';
      }
      return null;
    },

    time2: function () {
      if (day <= 0 && hours <= 0 && minutes > 5) {
        return minutes + ' 分钟前';
      }
      return null;
    },

    time3: function () {
      if (day <= 0 && hours > 0 && hours <= 3) {
        return hours + ' 小时前';
      }
      return null;
    },

    time4: function () {
      if (day <= 0 && hours > 3) {
        if (nowDate === publishDate) {
          return '今天 ' + transform(h) + ':' + transform(m);
        } else {
          return '昨天 ' + transform(h) + ':' + transform(m);
        }
      }
      return null;
    },

    time5: function () {
      if (day > 0 && day <= 1) {
        if (nowDate === publishDate + 1) {
          return '昨天 ' + transform(h) + ':' + transform(m);
        } else {
          return '前天 ' + transform(h) + ':' + transform(m);
        }
      }
      return null;
    },

    time6: function () {
      if (day > 1) {
        if (thisYear !== publishYear) {
          return y + '年' + M + '月' + d + '日';
        } else {
          return M + '月' + d + '日';
        }
      }
      return null;
    },
  };

  for (const index in showTime) {
    if (showTime[index]()) {
      formatTime = showTime[index]();
    }
  }

  return formatTime;
}

function getSingle(fn) {
  let result;
  return function () {
    let forceUpdate = arguments[arguments.length - 1]?.forceUpdate; //强制更新单例
    console.log(forceUpdate);
    if (forceUpdate) return (result = fn.apply(null, arguments));
    return result || (result = fn.apply(null, arguments));
  };
}

function loadPraiseAnimationLottie(lottieDom, theme) {
  const animation = window.lottie.loadAnimation({
    container: lottieDom,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: theme === 'day' ? like : likeDark,
  });
  return animation;
}

export const creatSingleAnimation = getSingle(loadPraiseAnimationLottie);

export function playPraiseAnimation(animation, isThumbUp) {
  isThumbUp
    ? animation.playSegments([0, 39], true)
    : animation.playSegments([39, 53], true);
}

//返回合理的截断位置index，防止截断表情图
export function getSplitIndex(content, initMaxLength) {
  //判断截断位置是否有emoji图标
  let contentMaxLength = initMaxLength;
  if (content.length > initMaxLength) {
    const hasEmj = content
      .slice(initMaxLength - 1, initMaxLength + 1)
      .match(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/);
    if (hasEmj) {
      contentMaxLength = initMaxLength + 1;
    }
  }
  return contentMaxLength;
}

//埋点上报，对应埋点文档：https://doc.myoas.com/pages/viewpage.action?pageId=421692696
export function templateDataReport(wv) {
  // 从localStorage中获取埋点上报数据后清除处理
  let reportData = JSON.parse(
    localStorage.getItem(window['docid'] + '_reportData'),
  );
  localStorage.removeItem(window['docid']);
  if (reportData == null || !reportData) return;

  let ls_load_start = reportData.ls_load_start;
  let ls_get_content = reportData.ls_get_content;
  let ls_reload = reportData.ls_reload;
  let ls_get_content_time = reportData.ls_get_content_time;
  let ls_render_time = reportData.ls_render_time;
  let ls_reload_time = reportData.ls_reload_time;
  let ls_template_time = reportData.ls_template_time;
  let ls_loading_time = reportData.ls_loading_time;
  let ls_firstImg_time = reportData.ls_firstImg_time;

  // 定义上报方法
  let reportFn = function (id, key, str) {
    let jsonStr = {
      template: '1_2',
      url: window.location.href,
      docid: window['docid'],
      source: 'oppo',
    };
    key ? (jsonStr[key] = str) : '';
    wv.generalStat([id, 10012, 21006, JSON.stringify(jsonStr)]);
  };

  // 客户端内进行上报
  if (wv.isMethodValid('generalStat')) {
    // 获取客户端点击到模板起始节点耗时
    try {
      let clickTime = Number(
        window.BrowserIFlow.getTemplateClickTime(window['docid']),
      );
      if (clickTime > 0) {
        // 加载信息流静态模板的起始节点
        ls_load_start ? reportFn(20083522) : '';

        // 获取到客户端返回文章内容
        reportFn(20083523, 'result', ls_get_content);

        // 获取客户端返回数据为空的情况下，重试加载
        reportFn(20083524, 'result', ls_reload);

        // 统计首页点击到开始加载静态模板的耗时
        if (window['initStart'] - clickTime < 1000) {
          reportFn(20083525, 'loadTime', window['initStart'] - clickTime);
          console.log('客户端&内核加载耗时：', window['initStart'] - clickTime);
        }

        // 统计调用客户端获取文章内容的耗时
        if (ls_get_content_time > 0) {
          reportFn(20083526, 'loadTime', ls_get_content_time);
        }

        // 统计获取正文后到内容渲染的耗时
        if (ls_render_time > 0) {
          reportFn(20083527, 'renderTime', ls_render_time);
        }

        // 统计客户端返回为空的场景下，重试成功的耗时
        if (ls_reload_time > 0) {
          reportFn(20083528, 'loadTime', ls_reload_time);
        }

        // 统计H5模板加载耗时（从H5模板加载到内容展示的耗时）
        if (ls_template_time > 0) {
          reportFn(20083529, 'loadTime', ls_template_time);
          console.log('加载前端模板到有内容展示耗时：', ls_template_time);
        }

        // 统计点击到有内容展示的耗时
        if (ls_loading_time - clickTime < 1000) {
          reportFn(20083530, 'loadTime', ls_loading_time - clickTime);
          console.log('页面加载总耗时：', ls_loading_time - clickTime);
        }

        // 统计首图加载的耗时
        if (ls_firstImg_time > 0) {
          reportFn(20083531, 'loadTime', ls_firstImg_time);
        }
      }
    } catch (error) {
      console.log('获取客户端点击起始时间failed');
    }
  }
}

/**
 * 判断当前版本号是否高于指定版本，忽略小版本号
 * 作者：崔頔（80261212）
 * @param baseVersion {String} - 要比较的版本号，如“7.26”
 * @param currentVersion {String} - 当前版本号，如“40.7.26.1der”
 * @param containEqual {Boolean} - 是否包含等号
 * @returns {boolean} 是否高于指定版本
 */
export function isBrowserVersionHigherThan(
  baseVersion,
  currentVersion,
  containEqual = true,
) {
  try {
    const parseVersion = (versionArr) => {
      // 给大版本号一个权重，防止 8.1 < 7.26 的现象
      // [8000, 1] [7000, 39]
      return versionArr[0] * 1000 + versionArr[1] * 1;
    };
    // 转换成数字的版本，方便比较
    const versionToNum = (version) => {
      version = version.split('.');
      if (version.length >= 4) {
        // 去掉前面的 10/20/40，保留三位
        version = version.slice(1, 4);
      }
      // 去掉最后的小版本号
      version = version.slice(0, -1);
      return Number(parseVersion(version));
    };

    let version = currentVersion;
    if (!currentVersion) {
      // 没传版本时，取 ua 上的版本
      const ua = window.navigator.userAgent.toLowerCase();
      const regExpUa = /(oppo|nearme|realme|oneplus|heytap)browser\/([0-9.]+)/i;
      const matched = ua.match(regExpUa);
      if (matched && matched.length === 3) {
        version = matched[2];
      }
    } else {
      // 去掉版本号最后可能存在的 der 等后缀
      const regExpNum = /[0-9.]+/;
      const matched = version.match(regExpNum);
      if (matched) {
        version = matched[0];
      }
    }

    if (version) {
      const baseVersionNum = Number(
        parseVersion(('' + baseVersion).split('.')),
      );
      return containEqual
        ? versionToNum(version) >= baseVersionNum
        : versionToNum(version) > baseVersionNum;
    }
    return false;
  } catch (e) {
    return false;
  }
}

const jumpGameCenterFnName = 'BrowserWeb.jumpGameCenterWithCallback';
/**
 * 跳转游戏中心的页面
 * @param {*} params ['dp链接']
 */
export function jumpGameCenter(params) {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === 'development') {
      return resolve({});
    }
    if (window.wv.isMethodValid(jumpGameCenterFnName)) {
      const timerId = setTimeout(() => {
        resolve({});
      }, 5000);
      window.wv.invoke(jumpGameCenterFnName, params, (data) => {
        clearTimeout(timerId);
        resolve(data);
      });
    } else {
      const result = window.wv.jumpGameCenter(params);
      resolve(result);
    }
  });
}

/**
 * 文件大小格式化
 * @param {Number} bytes 字节
 * @param {Number} decimalLen 保留几位小数
 * @returns
 */
export function bytesToSize(bytes, decimalLen = 2) {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return (bytes / Math.pow(k, i)).toFixed(decimalLen) + ' ' + sizes[i];
}

// 格式化数量
export function formatNumber(value, degree = 10, split = ' ', suffix = '') {
  const num = +value;
  if (num || num === 0) {
    if (num >= 10000000) {
      return (
        Math.round((num / 100000000) * degree) / degree + split + '亿' + suffix
      );
    } else if (num >= 1000) {
      return (
        Math.round((num / 10000) * degree) / degree + split + '万' + suffix
      );
    }
    return num + split + suffix;
  }
  return value;
}

// 获取当前客户端搜索引擎
export function getEngine() {
  const engineData = window.wv?.getSearchEngine?.()?.data;
  let engine;
  if (engineData) {
    engine = engineData.split('<|>')[0];
  } else {
    engine = 'toutiao';
  }
  return engine;
}

// 负一屏
export const isAssistantScreen = cached(() => {
  let appName = '';
  try {
    let appNameJson =
      (window.HeytapApi &&
        window.HeytapApi.invokeApi('Common.getAppName', '[]')) ||
      '{}';
    appName = JSON.parse(appNameJson).data;
  } catch (error) {
    console.log(error);
  }
  return (
    /assistantscreen/.test(ua) ||
    appName === '速览' ||
    appName === 'assistantscreen'
  );
});

// 锁屏杂志
export function isPictorial() {
  return /pictorial/.test(ua);
}

export function isCommonSdk() {
  return !!window.pageData?.isCommonSdk;
}
// 日历
export function isCalendar() {
  return isNativeCode('CalendarWebView.getKKUA');
}

// 天气app
export function isWeatherApp() {
  return isNativeCode('OppoWebPage.getUUKA');
}

// 钱包
export function isWallet() {
  return (
    (/wallet/i.test(ua) ||
      (/FinshellWebSDK/i.test(ua) && /JSBridge\/\w+ tas/i.test(ua))) &&
    !/hap/i.test(ua)
  );
}

const APP = {
  SCREEN: 'screen', // 锁屏杂志
  ASSISTANTSCREEN: 'assistantscreen', // 负一屏
  BROWSER: 'browser', // 浏览器
  CALENDAR: 'calendar', // 日历
  WEATHER: 'weather', // 天气
  WALLET: 'wallet', // 钱包
  COMMONSDK: 'gsearch', // 通用信息流
};

/**
 * 获取所有端标识
 */
export function getPageApp() {
  switch (true) {
    case isCommonSdk():
      return APP.COMMONSDK;
    case Browser.isOppoBrowser():
      return APP.BROWSER;
    case isPictorial():
      return APP.SCREEN;
    case isAssistantScreen():
      return APP.ASSISTANTSCREEN;
    case isCalendar():
      return APP.CALENDAR;
    case isWeatherApp():
      return APP.WEATHER;
    case isWallet():
      return APP.WALLET;
  }
  return '';
}
